import { createFeatureSelector, createSelector } from "@ngrx/store";

import {
    RegisterYourInterestState,
    RegisterYourInterestStatus,
} from "../models/register-your-interest.models";
import { REGISTER_YOUR_INTEREST_FEATURE_KEY } from "../reducers/register-your-interest.reducer";

export const selectRegisterYourInterestState =
    createFeatureSelector<RegisterYourInterestState>(
        REGISTER_YOUR_INTEREST_FEATURE_KEY,
    );

export const selectRegisterYourInterestLoading = createSelector(
    selectRegisterYourInterestState,
    (registerYourInterestState: RegisterYourInterestState) =>
        registerYourInterestState.status === RegisterYourInterestStatus.Loading,
);

export const selectRegisterYourInterestCustomerType = createSelector(
    selectRegisterYourInterestState,
    (registerYourInterestState: RegisterYourInterestState) =>
        registerYourInterestState.customerType,
);
